exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-974379da] {\n  background: #ebeff3;\n  border-radius: 10px;\n}\n.field-wrapper[data-v-974379da] {\n  background: #ebeff3;\n  padding: 12px;\n  margin-bottom: 10px;\n  border-radius: 8px;\n}\n.form-group label[data-v-974379da] {\n  font-weight: 500;\n}\n.text-success[data-v-974379da] {\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-974379da","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/apiResponseJsonFormatter.vue
// module id = 1388
// module chunks = 2